import styled from "@emotion/styled";
import {ReactComponent as svg} from "../../../../images/iconLog.svg";

export const LogsSvg = styled(svg)`
    padding-top: 4px;
`;